/**
 * The homepage lead form comes in two variants, chosen in Setări curs.
 *
 *   contact  — first name, last name, email, phone; "te contactăm noi".
 *   brochure — the original form: teaching profile, school and county, and the
 *              brochure by email.
 *
 * Everything that differs in WORDS lives here, so the form, the header and the
 * mobile bar cannot drift into promising a brochure the server no longer sends.
 * Which fields are required is enforced again on the server, from the setting
 * itself — this module only decides what the visitor reads.
 */

export const LEAD_FORM_MODES = ["contact", "brochure"];
export const DEFAULT_LEAD_FORM_MODE = "contact";

export function normalizeLeadFormMode(mode) {
  return LEAD_FORM_MODES.includes(mode) ? mode : DEFAULT_LEAD_FORM_MODE;
}

const COPY = {
  contact: {
    eyebrow: "Ai întrebări?",
    title: "Vrei să afli mai multe detalii?",
    subtitle: "Completează formularul și te contactăm noi.",
    doneTitle: "Mulțumim!",
    doneBody: "Am primit datele tale. Te contactăm în curând.",
    toastSuccess: "Mulțumim! Te contactăm în curând.",
    marketingLabel:
      "Sunt de acord să primesc pe email informații despre cursuri și alte programe ale Fundației pentru Educație Digitală.",
    marketingRequired: false,
    phoneRequired: true,
    profileFields: false,
    headerCta: "Cere detalii",
    stickyCta: "Vreau detalii",
  },
  brochure: {
    eyebrow: "Cere broșura cursului",
    title: "Completează formularul și îți trimitem broșura de prezentare a cursului pe email.",
    subtitle: "Verifică inboxul în câteva minute – iar dacă ai întrebări, răspunde direct emailului.",
    doneTitle: "Mulțumim!",
    doneBody: "Verifică-ți emailul în următoarele câteva minute. Ți-am trimis tot ce ai nevoie.",
    toastSuccess: "Mulțumim! Ți-am trimis broșura de prezentare a cursului pe email.",
    marketingLabel:
      "Sunt de acord să primesc pe email/telefon broșura cursului și alte informații despre programele Fundației pentru Educație Digitală.",
    marketingRequired: true,
    phoneRequired: false,
    profileFields: true,
    headerCta: "Cere broșura",
    stickyCta: "Vreau broșura",
  },
};

export function leadFormCopy(mode) {
  return COPY[normalizeLeadFormMode(mode)];
}

/** Digits only, 9 to 15 — the same rule the server applies. */
export function isPlausiblePhone(value) {
  const digits = String(value || "").replace(/\D/g, "");
  return digits.length >= 9 && digits.length <= 15;
}
